import { sheetNavGuard, sheetStore, useSheetStack } from '@shared-core/navigation/sheet-store'
import { isRegisteredSheetKey, SHEET_REGISTRY } from '@web/sheets/registry'
import { SheetContainer } from '@web/sheets/sheet-container'
import { useEffect } from 'react'

// Монтируется один раз в корне приложения. Рендерит стек открытых шитов.
export function SheetHost() {
  const stack = useSheetStack()

  useEffect(() => {
    // Браузерный «Назад» (и свайп-назад) закрывает верхний открытый шит.
    const onPopState = () => {
      if (sheetNavGuard.consumePopstateSuppress()) return

      if (!sheetStore.hasOpen()) return

      // Обязательные шторки (dismissible: false) нельзя закрыть навигацией «Назад» — возвращаем историю вперёд.
      const topKey = sheetStore.topKey()
      const entry = topKey && isRegisteredSheetKey(topKey) ? SHEET_REGISTRY[topKey] : null

      if (entry?.options?.dismissible === false) {
        // Копируем текущий state: pushState(null) обнулил бы idx react-router'а,
        // и весь дальнейший подсчёт шагов истории (popTo / exit-cross) сломался бы.
        window.history.pushState(window.history.state, '')
        return
      }

      sheetStore.closeTop()
    }

    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  return (
    <>
      {stack.map((instance, index) => (
        <SheetContainer
          key={instance.id}
          instance={instance}
          layerIndex={index}
          isTopLayer={index === stack.length - 1}
        />
      ))}
    </>
  )
}
